import React from 'react';
import { hasValidSettings } from '../common/utils';
import { Box, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';

const SettingsGreyBox = ({ brandSettings, brandSalesforceId, showModal }) => {
  const intl = useIntl();
  const i18n = translations.Agenda(intl).agenda.page.dialogs.settingsGreyBox;
  if (!brandSalesforceId || !brandSettings || !hasValidSettings(brandSettings))
    return <></>;

  return (
    <Box
      bgcolor={'#EEEEEE'}
      border={'1px solid #777777'}
      padding={'25px 15px'}
      width={'100%'}
      sx={{ marginTop: '20px' }}
    >
      <Stack flexDirection={'row'} gap={'15px'} alignItems={'flex-start'}>
        <InfoOutlinedIcon sx={{ color: '#333333' }} fontSize="small" />
        <Stack>
          <Typography variant="body1-bold" sx={{ mb: '15px' }}>
            {i18n.title}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                {i18n.prenotazione_appuntamenti}{' '}
                {brandSettings.prenotazione_appuntamenti === '0'
                  ? i18n.prenotazione_appuntamentiOn
                  : i18n.prenotazione_appuntamentiOff}
                .
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {i18n.email} {brandSettings.email}.
              </Typography>
            </li>
          </ul>
          <Typography
            variant="link2"
            color="primary"
            style={{
              marginTop: '20px',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={showModal}
          >
            {i18n.btn}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
export default SettingsGreyBox;
